export const floatData = [
  {
    head: 'Treatment-Resistant Depression Defined',
    copy: [
      'Clinical depression (major depressive disorder) is a common and serious medical illness that negatively affects how you feel, the way you think and how you act.',
      '1',
      ' Fortunately, it is treatable, but there are some forms of depression that are more complex and difficult to treat. One form of depression that is more challenging to treat is treatment-resistant depression, or TRD. TRD is often defined as an inadequate response to two or more antidepressants (of adequate dose and duration) in the current depressive episode, which is why many who are diagnosed with this form of depression cycle through treatments without relief.',
      '3'
    ],
    copyType: ['text', 'sup', 'text', 'sup']
  },
  {
    quote:
      'People would say, ‘Why are you not happy? ...You have everything,’ and they weren’t wrong...”',
    name: 'Grace'
  },
  {
    quote:
      'I encourage anybody that’s starting this journey to have a lot of grace with themselves.”',
    name: 'Allison'
  }
];
